const academy = () => import(/* webpackChunkName: "academy" */ '@/pages/academy');
const academyVideos = () => import(/* webpackChunkName: "academy" */ '@/pages/academy/videos');

export default [
  {
    path: 'academy',
    name: 'Academy',
    alias: '',
    component: academy,
  },
  {
    path: 'academyVideos',
    name: 'Academy Videos',
    alias: '',
    component: academyVideos,
  },
];
